import React from "react";
import { DynamicTable, TextAlignCenterDiv, Link, ReactRouter, useQuery } from "@atlassiansox/microscopekit";
import Lozenge from "@atlaskit/lozenge";
import { Filter } from "../../../components";
import { WarGameExerciseForServiceQuery } from "../../../graphql";
import { wargameExerciseStatuses } from "../../../models";
export var WargameExercisesListView = function (_a) {
    var serviceId = _a.serviceId;
    var _b = useWargameExercises(serviceId), isLoading = _b.isLoading, wargameExercises = _b.wargameExercises;
    var url = ReactRouter.useRouteMatch().url;
    return (React.createElement("div", null,
        React.createElement("br", null),
        React.createElement(Filter, { entities: wargameExercises, fields: {
                id: "Id",
                name: "Name",
                status: "Status"
            }, render: function (filteredWargameExercises) { return (React.createElement(DynamicTable, { caption: "Wargame Exercises", isFixedSize: true, emptyView: React.createElement(TextAlignCenterDiv, null, "No Wargame Exercises found!"), isLoading: isLoading, rowsPerPage: 10, defaultSortKey: "ID", defaultSortOrder: "DESC", head: {
                    cells: [
                        {
                            key: "ID",
                            content: "ID",
                            isSortable: true,
                            width: 10
                        },
                        {
                            key: "Name",
                            content: "Name",
                            isSortable: true,
                            width: 40
                        },
                        {
                            key: "Due Date",
                            content: "Due Date",
                            isSortable: true,
                            width: 15
                        },
                        {
                            key: "Status",
                            content: "Status",
                            isSortable: true,
                            width: 25
                        }
                    ]
                }, rows: filteredWargameExercises.map(function (wargameExercise) { return ({
                    key: wargameExercise.id,
                    cells: [
                        {
                            content: wargameExercise.id.toString()
                        },
                        {
                            content: (React.createElement(Link, { to: url + "/exercise/" + wargameExercise.id }, wargameExercise.name))
                        },
                        {
                            content: wargameExercise.end_date
                                ? new Date(wargameExercise.end_date).toLocaleDateString()
                                : ""
                        },
                        {
                            content: (React.createElement(WargameExerciseStatus, { status: wargameExercise.status }))
                        }
                    ]
                }); }) })); } })));
};
var useWargameExercises = function (serviceId) {
    var _a;
    var _b = useQuery(WarGameExerciseForServiceQuery, { variables: { service: serviceId } }), data = _b.data, loading = _b.loading;
    var wargameExercises = (_a = data === null || data === void 0 ? void 0 : data.warGameExerciseForService.rows) !== null && _a !== void 0 ? _a : [];
    return {
        wargameExercises: wargameExercises,
        isLoading: loading
    };
};
var WargameExerciseStatus = function (_a) {
    var _b;
    var _c, _d, _e;
    var status = _a.status;
    var statusLabel = (_d = (_c = Object.values(wargameExerciseStatuses).find(function (_a) {
        var name = _a.name;
        return name === status;
    })) === null || _c === void 0 ? void 0 : _c.label) !== null && _d !== void 0 ? _d : "";
    var appearanceMapping = (_b = {},
        _b[wargameExerciseStatuses.todo.name] = "new",
        _b[wargameExerciseStatuses.brainstormAndWalkthrough.name] = "inprogress",
        _b[wargameExerciseStatuses.prepareExperiments.name] = "inprogress",
        _b[wargameExerciseStatuses.executeExperiments.name] = "inprogress",
        _b[wargameExerciseStatuses.done.name] = "success",
        _b[wargameExerciseStatuses.cancelled.name] = "removed",
        _b);
    var appearance = (_e = appearanceMapping[status]) !== null && _e !== void 0 ? _e : "default";
    return React.createElement(Lozenge, { appearance: appearance }, statusLabel);
};
